import "../css/widget.css";
import { NavLink } from "react-router-dom";

// firebase
import { useState, useEffect } from "react";
import { db } from "../firestore-db";
import 'firebase/compat/firestore';
import {
    collection,
    getDocs,
    updateDoc,
    deleteDoc,
    doc,
} from "firebase/firestore";

import * as FaIcons from 'react-icons/fa';
import * as GoIcons from "react-icons/go";

const WidgetSummary = ({ type }) => {
    let data;

    const [totalUsers, setTotalUsers] = useState(0);
    const [totalTutors, setTotalTutors] = useState(0);
    const [totalTutees, setTotalTutees] = useState(0);
    const [totalReq, setTotalReq] = useState(0);

    // Tutee Count
    useEffect(() => {
        db.collection("users").where("userType", "==", "Tutee").get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {

                    const Total = querySnapshot.size
                    setTotalTutees(Total);

                });
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
    }, []);

    // tutor count
    useEffect(() => {
        db.collection("users").where("userType", "==", "Tutor").get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {

                    const Total = querySnapshot.size
                    setTotalTutors(Total);

                });
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
    }, []);

    // total user count
    useEffect(() => {
        db.collection("users").get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {

                    const Total = querySnapshot.size
                    setTotalUsers(Total);

                });
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
    }, []);

    //req count
    useEffect(() => {
        db.collection("users").where("userVerification","==", "false").get()
            .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {

                    const Total = querySnapshot.size
                    setTotalReq(Total);

                });
            })
            .catch((error) => {
                console.log("Error getting documents: ", error);
            });
    }, []);

    switch (type) {
        case "tutees":
            data = {
                title: "Total Tutees",
                link: "View details",
                path: "/mngusers",
                amount: totalTutees,
                icon: <FaIcons.FaUserGraduate
                    className="icons"
                    style={{
                        backgroundColor: "rgba(128, 0, 128, 0.2)",
                        color: "purple",
                    }} />,
            };
            break;

        case "tutors":
            data = {
                title: "Total Tutors",
                link: "View details",
                path: "/mngusers",
                amount: totalTutors,
                icon: <FaIcons.FaUserTie
                    className="icons"
                    style={{
                        backgroundColor: "rgba(128, 0, 128, 0.2)",
                        color: "purple",
                    }} />,
            };
            break;

        case "users":
            data = {
                title: "Total Users",
                link: "View details",
                path: "/mngusers",
                amount: totalUsers,
                icon: <FaIcons.FaUsers
                    className="icons"
                    style={{
                        backgroundColor: "rgba(128, 0, 128, 0.2)",
                        color: "purple",
                    }} />,
            };
            break;

        case "verify":
            data = {
                title: "Total Verification Requests",
                link: "View details", 
                path: "/verifyusers",
                amount: totalReq,
                icon: <GoIcons.GoUnverified
                    className="icons"
                    style={{
                        backgroundColor: "rgba(128, 0, 128, 0.2)",
                        color: "purple",
                    }} />,
            };
            break;
        default:
            break;
    }

    return (
        <div className="widget">
            <div className="left">
                <span className="widget-title"> {data.title} </span>
                <span className="counter">
                    {data.amount}
                </span>
                <span>
                    <NavLink to={data.path} className="widget-link" > {data.link} </NavLink>
                </span>
            </div>
            <div className="right">
                {data.icon}
            </div>
        </div>
    );
};

export default WidgetSummary;